export const getDeliveryDesignOptions = ({
  availableDesigns,
  bales,
  baleIndex,
  lineIndex,
  designSummaries,
}) => {
  const currentDesign = bales[baleIndex]?.fabric_lines?.[lineIndex]?.design_number || '';
  const selectedByOtherLines = new Set();

  bales.forEach((bale, currentBaleIndex) => {
    (bale.fabric_lines || []).forEach((line, currentLineIndex) => {
      if (currentBaleIndex === baleIndex && currentLineIndex === lineIndex) return;
      if (line.design_number) selectedByOtherLines.add(line.design_number);
    });
  });

  return availableDesigns.filter((design) => {
    if (design.design_number === currentDesign) return true;
    const summary = designSummaries[design.design_number];
    const pendingQuantity = summary?.pending_qty ?? design.max_quantity ?? 0;
    return pendingQuantity > 0 && !selectedByOtherLines.has(design.design_number);
  });
};